import { observer } from "mobx-react";
import {
  getSubscriptionFormCustomPanels,
  SubscriptionFormCustomPanel,
  SubscriptionFormForm,
} from "./subscriptionFormDomain";
import {
  DetailsSummaryList,
  DocumentLanguageSelector,
  DocumentSigningStatusLine,
  ReopenDocumentButton,
} from "@/dbot/common/commonComponents";
import { when } from "@/utils/functions";
import { Button } from "@/components-v2/Button";
import { isPending } from "@/common/common";
import { Alert } from "@/components-v2/Alert";
import { useTranslation } from "@/stores/RootStoreContext";
import { DetailsPanel } from "@/dbot/common/commonDomain";
import { VBox } from "@/components-v2/Box";
import { LocalizedTextEditor } from "@/text/LocalizedTextEditor";

export const SubscriptionFormDetailsPanel = observer(function NoticeToGeneralMeetingDetailsPanel({
  panel,
  form,
}: {
  panel: DetailsPanel;
  form: SubscriptionFormForm;
}) {
  switch (panel.type) {
    case "custom":
      switch (panel.id) {
        case SubscriptionFormCustomPanel.settings:
          return <SubscriptionFormDetails form={form} />;
      }
  }
  return null;
});

export const SubscriptionFormDetails = observer(function SubscriptionFormDetails({
  form,
}: {
  form: SubscriptionFormForm;
}) {
  return (
    <VBox gap={"md"}>
      <DocumentLanguageSelector field={form.documentLanguage} isLocked={form.isLocked} />
      <LocalizedTextEditor model={form.additionalDetailsTextModel} />
    </VBox>
  );
});

export const SubscriptionFormView2 = observer(function SubscriptionFormView2({
  form,
}: {
  form: SubscriptionFormForm;
}) {
  const { t } = useTranslation();
  return (
    <>
      <DocumentSigningStatusLine context={form.context} dispatch={form.dispatch} />
      <DetailsSummaryList
        dispatch={form.dispatch}
        isLocked={form.isLocked}
        panels={getSubscriptionFormCustomPanels(form)}
      />
      {when(form.openBatchPreviewAction(t(form.documentItem.title)), (action) => (
        <Button variant={"secondary"} label={action.label} onClick={() => form.dispatch(action)} />
      ))}
      {when(form.downloadSignedSubscriptionFormsAction, (action) => (
        <Button
          variant={"secondary"}
          label={action.label}
          onClick={() => form.dispatch(action)}
          disabled={form.isDownloadDocumentDisabled}
        />
      ))}
      {when(form.openSendForSigningDialogAction, (action) => (
        <Button
          variant={"primary"}
          label={{ key: "documents.subscriptionForm.sendAll" }}
          loading={isPending(form.context.documentSigners.get(form.documentId))}
          disabled={!form.isRequiredDocumentSentForSigning}
          onClick={() => form.dispatch(action)}
        />
      ))}
      {!form.isIncreaseShareCapitalDecisionAdded && (
        <Alert message={{ key: "documents.subscriptionForm.missingDecision" }} type={"info"} />
      )}
      {form.showSendRequiredDocument && (
        <small className={"subtle"}>{t(form.requiredDocumentLabel)}</small>
      )}
      <ReopenDocumentButton context={form.context} dispatch={form.dispatch} />
    </>
  );
});
